import { Component, OnInit } from "@angular/core";
import { GeneralService } from "../../services/general.service";

@Component({
  selector: "app-box-offline",
  templateUrl: "./box-offline.component.html",
  styleUrls: ["./box-offline.component.scss"],
})
export class BoxOfflineComponent implements OnInit {
  customerServiceNumber: string;

  constructor(private generalService: GeneralService) {}

  ngOnInit() {
    this.customerServiceNumber = this.generalService.getCustomerSupportNumber();
  }

  updateBoxConnectionStatus() {
    this.generalService
      .getBoxConnectionStatus()
      .subscribe((state) => this.generalService.connChange.next(state));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/box-offline/box-offline.component.ts